const IconChecklist = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={props.fill}
      stroke={props.stroke}
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 5.5L3.21429 7L7.5 3"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12.5L3.21429 14L7.5 10"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 19.5L3.21429 21L7.5 17"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M22 19L12 19" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M22 12L12 12" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M22 5L12 5" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}

export default IconChecklist
